/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalFormSchemaAnswerOption
 */
export interface SupplementalFormSchemaAnswerOption {
    /**
     * 
     * @type {string}
     * @memberof SupplementalFormSchemaAnswerOption
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalFormSchemaAnswerOption
     */
    label?: string;
}

/**
 * Check if a given object implements the SupplementalFormSchemaAnswerOption interface.
 */
export function instanceOfSupplementalFormSchemaAnswerOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalFormSchemaAnswerOptionFromJSON(json: any): SupplementalFormSchemaAnswerOption {
    return SupplementalFormSchemaAnswerOptionFromJSONTyped(json, false);
}

export function SupplementalFormSchemaAnswerOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalFormSchemaAnswerOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function SupplementalFormSchemaAnswerOptionToJSON(value?: SupplementalFormSchemaAnswerOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'label': value.label,
    };
}

